import WeatherCard from './WeatherCard';

const WeatherDashboard = ({ station, datos_meteo, stella_data, song_data, config }) => {

  return (
    
    <div className="mb-4" style={{ width: '90%', margin : "0px auto" }}>

      <div className="mt-2 fs-6">Data time: {datos_meteo.time} UT - <strong>Station: </strong> {station}</div>

      <div className="row gx-1">
        <div className="col">
          <WeatherCard title="Temperature" value={datos_meteo.temperature} unit="°C" />
        </div>
        <div className="col">
          <WeatherCard title="Humidity" value={datos_meteo.humidity} unit="%"
                       limits={{'soft':config.limits.humidity.soft, 'hard': config.limits.humidity.hard}}
                      />
        </div>
        <div className="col">
          <WeatherCard title="Wind" value={datos_meteo.wind_speed} unit="m/s"
                       limits={{'soft':config.limits.wind_speed.soft, 'hard': config.limits.wind_speed.hard}}
                       />
        </div>
        <div className="col">
          <WeatherCard title="Wind gust" value={datos_meteo.wind_gust} unit="m/s"
                       limits={{'soft':config.limits.wind_gust.soft, 'hard': config.limits.wind_gust.hard}}
                       />
        </div>
        <div className="col">
          <WeatherCard title="Wind direction" value={datos_meteo.wind_direction} unit="º"/>
        </div>
        <div className="col">
          <WeatherCard title="Pressure" value={datos_meteo.pressure} unit="hPa" />
        </div>
        <div className="col">
          <WeatherCard title="Dust" value={stella_data.dust} unit="m⁻³"
                       limits={{'soft':config.limits.dust.soft, 'hard': config.limits.dust.hard}}
                       digits={4}
                      />
        </div>
        <div className="col">
          <WeatherCard title="Seeing" value={song_data.seeing} unit='"' digits={2} />
        </div>
      </div>
    </div>
  );
};

export default WeatherDashboard;
